<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="中转站(名称/类型/省份/城市/区县/详细地址)/联系人/托管机构/所属机构搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add',
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="中转站名字">
              <el-input
                v-model.trim="form.transferStationName"
                placeholder="请输入中转站名字"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="中转站类型">
              <dict-select
                v-model="form.transferStationType"
                placeholder="请选择中转站类型"
                default
                filterable
                :body="{ type: 'transferStationType' }"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

          <!-- <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="承运商">
              <dict-select
                style="width: 100%"
                size="medium"
                filterable
                v-model="form.carrierCode"
                url="/master/carrier/info/select"
                placeholder="请选择承运商"
                clearable
              />
            </el-form-item>
          </el-col> -->
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="联系人名字">
              <el-input
                v-model.trim="form.contactName"
                placeholder="请输入联系人名字"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="所属机构">
              <org-cascader :lastValue.sync="form.orgCode" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="托管机构">
              <org-cascader :lastValue.sync="form.trusteeshipOrgCode" />
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="省/市/县">
              <region-cascader
                filterable
                :show="true"
                :provinceCode.sync="form.provinceCode"
                :provinceName.sync="form.provinceName"
                :cityCode.sync="form.cityCode"
                :cityName.sync="form.cityName"
                :districtCode.sync="form.districtCode"
                :districtName.sync="form.districtName"
                :props="{ checkStrictly: true }"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="所在区域">
              <el-input
                v-model.trim="form.areaName"
                placeholder="请输入创建人名字"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="创建人名字">
              <el-input
                v-model.trim="form.createByName"
                placeholder="请输入创建人名字"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="修改人名字">
              <el-input
                v-model.trim="form.modifyByName"
                placeholder="请输入修改人名字"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top:10px">
          <el-form-item label="创建时间">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.createBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.createEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>

        <el-row style="margin-top:10px">
          <el-form-item label="修改时间">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="可用状态">
              <el-checkbox-group v-model="form.transferStationStatusList">
                <el-checkbox label="Y">有效</el-checkbox>
                <el-checkbox label="N">无效</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="是否虚拟中转站">
              <el-checkbox-group v-model="form.isVirtualList">
                <el-checkbox label="Y">是</el-checkbox>
                <el-checkbox label="N">否</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: "",
  transferStationStatusList: ["Y"],
  isVirtualList: ["Y", "N"],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()

    let _this = this
    this.$eventBus.$on("transferStationTableReload", function() {
      _this.query()
    })
  },
  methods: {
    // 普通查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit("reset")
      }
      this.$emit("query", this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: "master-transferStation-detail",
        params: { ...params, pageType },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
